import { defaultNotificationsConfig } from '@Configs/notifications';

export function notify(data) {
    import(MODULES_PATH + 'notifications').then(({ Notifications }) => {
        const notifications = new Notifications(defaultNotificationsConfig);
        notifications.show(data);
    });
}